// Configuração global das notificações (RF-01/04/05). Ponto único de duração por
// tom, tamanho da pilha e janela de desfazer — antes espalhados entre
// ToastProvider.tsx (DEFAULT_TOAST_MS, MAX_VISIBLE, EXIT_MS) e o CSS da região.
// O offset vertical vive em tokens.css (--toast-offset-top): é CSS puro, duplicar
// aqui criaria duas fontes de verdade que driftam.

/**
 * Duração default por tom, em ms. `0` = sticky: só sai no dismiss manual ou via
 * `update()`. `warning`/`danger` ficam mais tempo que `info`/`success` porque
 * carregam mais texto e costumam exigir releitura.
 */
export const TOAST_DURATION = {
  info: 4000,
  success: 4000,
  warning: 6000,
  danger: 6000,
  /** Permanece até virar success/danger por `update()` (RF-05). */
  loading: 0,
} as const;

/** Tons disponíveis. Derivado de TOAST_DURATION pra não existirem duas listas. */
export type ToastTone = keyof typeof TOAST_DURATION;

/**
 * Janela do "Desfazer" (RF-05/06). Deliberadamente maior que os demais tons: o
 * usuário precisa notar o toast, ler e decidir antes da ação virar definitiva.
 * Quem precisar de outra janela passa `durationMs` no `runUndoable`.
 */
export const TOAST_UNDO_MS = 5000;

/** Máximo de toasts empilhados; ao estourar, o mais antigo cai (FIFO). */
export const TOAST_MAX_VISIBLE = 3;

/**
 * Duração do movimento de entrada, saída e reposicionamento da pilha.
 * Deliberadamente mais lenta que `--duration-base` (180ms): a pilha percorre
 * distâncias maiores que um fade e a 180ms o movimento lê como corte, não como
 * deslocamento.
 */
export const TOAST_MOTION_MS = 400;

/**
 * Janela da animação de saída antes de remover do DOM.
 * 🔴 Casa com TOAST_MOTION_MS de propósito: é o timeout que arranca o nó da
 * árvore, então encurtá-lo faz o toast sumir no meio da própria animação.
 */
export const TOAST_EXIT_MS = TOAST_MOTION_MS;

/** Quantos px de cada toast de trás ficam à mostra na pilha colapsada. */
export const TOAST_STACK_PEEK = 14;

/** Quanto cada toast encolhe por posição atrás do da frente. */
export const TOAST_STACK_SCALE_STEP = 0.05;

/** Espaço entre toasts quando a pilha está expandida (hover/foco). */
export const TOAST_STACK_GAP = 12;
